export default {
	background: '#000',
};
